import React from 'react';
import { LoaderWrap, Loader, LoaderItem } from './styles';

const LazyLoader: React.FC = () => {
    return (
        <LoaderWrap>
            <Loader>
                <LoaderItem />
                <LoaderItem />
                <LoaderItem />
            </Loader>
        </LoaderWrap>
    );
};

export default LazyLoader;
